import axios from 'axios';
import { AppConfig, JWT } from '../config';
import { NotificationConstant } from './constants/NotificationConstant';
import { AlertAction } from './AlertAction';
import { Translate as t } from '../config/Translate';

const GetAll = () => async (dispatch) => {
	dispatch({ type: NotificationConstant.LOADING });
	try {
		const ret = await axios.get(AppConfig.API_SERVER_PATH + '/notification', JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: NotificationConstant.GET_ALL, list : ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		// IMP-091 §7: silent-error 가드 — 관측 가능한 warn + 빈 리스트 폴백
		console.warn('[NotificationAction.GetAll] failed — empty list fallback', {
			handler: 'NotificationAction.GetAll',
			reason: error?.message || String(error),
		});
		dispatch({ type: NotificationConstant.GET_ALL, list : [] });
	} finally {
		dispatch({ type: NotificationConstant.LOADED });
	}
};

const Read = (_id) => async (dispatch) => {
	dispatch({ type: NotificationConstant.LOADING });
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/notification/' + _id, { type : "read" }, JWT());
		if (ret.data?.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: NotificationConstant.READ, item : ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		// IMP-091 §7: silent-error 가드 — 관측 가능한 warn + 사용자 토스트
		console.warn('[NotificationAction.Read] failed', {
			handler: 'NotificationAction.Read',
			target: _id,
			reason: error?.message || String(error),
		});
		dispatch(AlertAction.Error(error));
	} finally {
		dispatch({ type: NotificationConstant.LOADED });
	}
};

const UnRead = (_id) => async (dispatch) => {
	dispatch({ type: NotificationConstant.LOADING });
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/notification/' + _id, { type : "unread" }, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: NotificationConstant.READ, item : ret.data.data });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		// IMP-091 §7: silent-error 가드 — 관측 가능한 warn + 사용자 토스트
		console.warn('[NotificationAction.UnRead] failed', {
			handler: 'NotificationAction.UnRead',
			target: _id,
			reason: error?.message || String(error),
		});
		dispatch(AlertAction.Error(error));
	} finally {
		dispatch({ type: NotificationConstant.LOADED });
	}
};

const ReadAll = () => async (dispatch) => {
	dispatch({ type: NotificationConstant.LOADING });
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/notification', { type : "readall" }, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch({ type: NotificationConstant.READALL });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		// IMP-091 §7: silent-error 가드 — 관측 가능한 warn + 사용자 토스트
		console.warn('[NotificationAction.ReadAll] failed', {
			handler: 'NotificationAction.ReadAll',
			target: 'all',
			reason: error?.message || String(error),
		});
		dispatch(AlertAction.Error(error));
	} finally {
		dispatch({ type: NotificationConstant.LOADED });
	}
};

const DeleteAll = () => async (dispatch) => {
	dispatch({ type: NotificationConstant.LOADING });
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/notification', { type : "deleteall" }, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.deleted')));
			dispatch({ type: NotificationConstant.DELETEALL });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		// IMP-091 §7: silent-error 가드 — 관측 가능한 warn + 사용자 토스트
		console.warn('[NotificationAction.DeleteAll] failed', {
			handler: 'NotificationAction.DeleteAll',
			target: 'all',
			reason: error?.message || String(error),
		});
		dispatch(AlertAction.Error(error));
	} finally {
		dispatch({ type: NotificationConstant.LOADED });
	}
};

const DeleteRead = () => async (dispatch) => {
	dispatch({ type: NotificationConstant.LOADING });
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/notification', { type : "deleteread" }, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.deleted')));
			dispatch({ type: NotificationConstant.DELETEREAD });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		// IMP-091 §7: silent-error 가드 — 관측 가능한 warn + 사용자 토스트
		console.warn('[NotificationAction.DeleteRead] failed', {
			handler: 'NotificationAction.DeleteRead',
			target: 'all',
			reason: error?.message || String(error),
		});
		dispatch(AlertAction.Error(error));
	} finally {
		dispatch({ type: NotificationConstant.LOADED });
	}
};

const Delete = (_id) => async (dispatch) => {
	dispatch({ type: NotificationConstant.LOADING });
	try {
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/notification/' + _id, { type: 'delete' }, JWT());
		if (ret.data.status == 'success') {
			dispatch(AlertAction.Success(t('common.message.deleted')));
			dispatch({ type: NotificationConstant.DELETE, _id : _id });
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		// IMP-091 §7: silent-error 가드 — 관측 가능한 warn + 사용자 토스트
		console.warn('[NotificationAction.Delete] failed', {
			handler: 'NotificationAction.Delete',
			target: _id,
			reason: error?.message || String(error),
		});
		dispatch(AlertAction.Error(error));
	} finally {
		dispatch({ type: NotificationConstant.LOADED });
	}
};

export const NotificationAction = {
	GetAll,
	Read,
	UnRead,
	ReadAll,
	DeleteAll,
	DeleteRead,
	Delete,
};
